// get the min/max from the pricing array based on current indication
// we first need to filter AND map the data to get it out of the deep nesting
// pricing "p[1]" below is a product object's pricing.<current indication>.array(< where 0 is the label and 1 is the price >)
// nonZeroPrice is a helper function to make sure we filter the pricing array down to only ones that contain a price

// the final return line [in each function] can be better understood here https://developer.mozilla.org/en-US/docs/web/javascript/reference/global_objects/array/sort
// when comparing a to b: return value below 0 will put a earlier in the array.  Greater than 0 will put b earlier than a.

const nonZeroPrice = (price) => {
	if (price > 0) return price
	else return false
}

export const sortPriceHigh = ({ a, b, products, indication }) => {
	let aMax = 0
	let bMax = 0
	if (Array.isArray(products[a].pricing[indication])) {
		aMax = Math.max(...products[a].pricing[indication]
			.filter(p => nonZeroPrice(p[1]))
			.map(p => p[1]))
	} else {
		aMax = products[a].pricing[indication]
	}

	if (Array.isArray(products[b].pricing[indication])) {
		bMax = Math.max(...products[b].pricing[indication]
			.filter(p => nonZeroPrice(p[1]))
			.map(p => p[1]))
	} else {
		bMax = products[b].pricing[indication]
	}

	return parseFloat(bMax) - parseFloat(aMax)
}

export const sortPriceLow = ({ a, b, products, indication }) => {
	let aMin = 0
	let bMin = 0
	if (Array.isArray(products[a].pricing[indication])) {
		aMin = Math.min(...products[a].pricing[indication]
			.filter(p => nonZeroPrice(p[1]))
			.map(p => p[1]))
	} else {
		aMin = products[a].pricing[indication]
	}
	if (Array.isArray(products[b].pricing[indication])) {
		bMin = Math.min(...products[b].pricing[indication]
			.filter(p => nonZeroPrice(p[1]))
			.map(p => p[1]))
	} else {
		bMin = products[b].pricing[indication]
	}

	return parseFloat(aMin) - parseFloat(bMin)
}

export const sortDateNew = ({ a, b, products }) => {
	return products[b].creation_time - products[a].creation_time
}

export const sortDateOld = ({ a, b, products }) => {
	return products[a].creation_time - products[b].creation_time
}
